/**
 * Form Container
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'cmp-footer';

export class Footer extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        copyrightText: this.element.querySelector('.cmp-footer__copyright-text'),
    };

    updateCopyrightYear = () => {
        if (!this.elements.copyrightText) return;
        const currentYear = new Date().getFullYear();
        const previousYear = currentYear - 1;
        if (this.elements.copyrightText.innerHTML.includes('YYYY')) {
            this.elements.copyrightText.innerHTML = this.elements.copyrightText.innerHTML.replace('YYYY', currentYear);
        } else if (this.elements.copyrightText.innerHTML.includes(previousYear)) {
            this.elements.copyrightText.innerHTML = this.elements.copyrightText.innerHTML.replace(previousYear, currentYear);
        }
    }

    /**
     * Initialize Component
     */
    init() {
        this.updateCopyrightYear();
    }
}

registerComponent(`.${componentName}`, Footer);
